<template>
  <div style="background: transparent; color: yellow; padding: 0px; height: 80%; width: 80%">
    <!-- <h2>BAR todo</h2> -->
    <!-- <div style="background: darkblue; color: yellow">widgetType {{ widgetType }} widget {{ widget }} widgetDetail {{ widgetDetail }}</div> -->

    <!-- {{ props.widgetDetail }} -->

    <div style="background: transparent; padding: 0px; overflow: hidden; margin-top: 33px; min-height: 105px; width: 140px">
      <DxChart id="chart" :data-source="dataSource">
        <DxSeries argument-field="day" value-field="oranges" name="My oranges" type="bar" color="#83facf" />
      </DxChart>

      <!-- <DxChart id="chart" :rotated="true" :title="props.widgetDetail" :data-source="props.widgetDetail">
        <DxArgumentAxis>
          <DxLabel :customize-text="customizeLabelText" />
        </DxArgumentAxis>
        <DxValueAxis>
          <DxTitle text="Populations, millions" />
          <DxTick :visible="true" />
          <DxLabel :visible="true" />
        </DxValueAxis>
        >
        <DxCommonSeriesSettings argument-field="providerName" type="stackedbar" /> -->

      <!--
				<DxSeries argument-field="contractMeasureName" value-field="actualYTD" name="completedCnt" type="bar" color="#ffaa66" >
					<DxLabel
					:visible="true"
					background-color="#1c77e3"
				/>
			</DxSeries> -->

      <!-- <DxSeries argument-field="providerName" value-field="completedCnt" name="Completed" type="bar" color="green">
          <DxLabel :visible="true" background-color="green" />
        </DxSeries> -->
      <!-- <DxSeries argument-field="contractMeasureName" value-field="incompleteCnt" name="incompleteCnt" type="bar" color="#ffaa66" >
					<DxLabel
					:visible="true"
					background-color="darkgoldenrod"
				/>

				</DxSeries>
				<DxSeries argument-field="contractMeasureName" value-field="eligible" name="eligible" type="bar" color="#ffaa66" >
					<DxLabel
					:visible="true"
					background-color="#1c77e3"
				/>
				</DxSeries>		<DxSeries argument-field="contractMeasureName" value-field="neededForTarget" name="neededForTarget" type="bar" color="#ffaa66" >
					<DxLabel
					:visible="true"
					background-color="#ff3600"
				/>
				</DxSeries> -->
      <!-- <DxSeries argument-field="providerName" value-field="incompleteCnt" name="My oranges" type="bar" color="#ffaa66" >
					<DxLabel
					:visible="true"
					background-color="#c18e92"
				/>
				</DxSeries> -->
      <!-- <DxLegend :column-count="2" position="inside" horizontal-alignment="right">
          <DxBorder :visible="true" />
        </DxLegend> -->
      <!--
        <DxExport :enabled="true" />
        <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" location="edge" />
      </DxChart> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import DxChart, { DxArgumentAxis, DxExport, DxSeries, DxValueAxis, DxLabel, DxLegend, DxTick, DxCommonSeriesSettings, DxTitle, DxBorder, DxTooltip } from "devextreme-vue/chart";

const dataSource = [
  {
    day: "Monday",
    oranges: 3,
  },
  {
    day: "Tuesday",
    oranges: 2,
  },
  {
    day: "Wednesday",
    oranges: 3,
  },
  {
    day: "Thursday",
    oranges: 4,
  },
  {
    day: "Friday",
    oranges: 6,
  },
  {
    day: "Saturday",
    oranges: 11,
  },
  {
    day: "Sunday",
    oranges: 4,
  },
];
// & PROPS
const props = defineProps({
  widgetType: {
    type: Number,
    Default: () => {},
    required: true,
  },
  widget: {
    type: Object,
    Default: () => {},
  },
  widgetDetail: {
    type: Object,
    Default: () => {},
  },
});

const AreIdsShown = ref(true);
1;
onMounted(() => {
// console.log("onMounted() :      		WIDGET BAR CHART >>>>");
// console.log(" prop   widgetDetail ");
// console.log("props : ");
// console.log(props);
// console.log(props.widgetDetail);
});
</script>

<style scoped>
#chart {
  height: 60px;
}
</style>
